export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#D4AF37]/20 px-6 py-14"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 text-center">
        <span className="font-serif-lux text-lg tracking-[0.25em] text-white">
          CORTISOLO <span className="text-[#D4AF37]">ZERO</span>
        </span>
        <div className="h-px w-24 bg-[#D4AF37]/40" />
        <p data-testid="footer-email" className="text-sm text-[#A3A3A3]">
          Contatto Istituzionale:{" "}
          <a
            href="mailto:info@joe-fenix-method.com"
            className="text-[#D4AF37] transition-colors duration-300 hover:text-[#F3E5AB]"
          >
            info@joe-fenix-method.com
          </a>
        </p>
        <p className="text-xs text-[#4d4d4d]">
          © 2026 Joe Fenix Method. Tutti i diritti riservati. Protocollo ad alta
          prestazione riservato a professionisti.
        </p>
      </div>
    </footer>
  );
}
